import React, { useState, useEffect } from "react";
import emailPreviewImage from "../../../assets/images/emailPreview.svg";
import callPreviewImage from "../../../assets/images/aiCallPreview.svg";
import { EditFilled } from "@ant-design/icons";
import { useSpin } from "../../../components/SpinContext";
import {
  initiateAiCall,
  initiateAiCallValidate,
  shipmentAlertAiStatus,
} from "../../../api's/shipment";
import { useToken } from "../../../common/helper";
import phoneblack from "../../../assets/images/phoneBlack.svg";
import {
  CustomTitle,
  CustomParagraph,
  CustomButton,
  CustomModalWithoutButton,
} from "../../../components";

const AiAssistance = ({
  selected,
  aiMessage,
  setAiMessage,
  selectedNotificationMethod,
  onMessageChange,
  defaultMessage,
}) => {
  const [message, setMessage] = useState(defaultMessage || "");
  const { showSpin, hideSpin } = useSpin();
  const { decodedUserToken, getUserID, token } = useToken();
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  let decodedToken = decodedUserToken();
  const [isEditing, setIsEditing] = useState(false);
  const companyName = decodedToken?.company_name;
  const [modalOpen, setModalOpen] = useState(false);
  const handleMessageChange = (e) => {
    const newMessage = e.target.value;
    setAiMessage(newMessage);
    onMessageChange?.(newMessage);
  };

  const shipment = {};
  const handleAiCallConfirm = (alertData) => {
    if (!alertData || !shipment) {
      message.error("Shipment is not ready yet.");
      return;
    }

    const aiCallPayload = {
      ai_alert_event_uuid: alertData?.id,
      company: decodedToken?.company_name,
      triggered_by: getUserID(),
      alert: {
        name: alertData?.title,
        description: alertData?.detail,
        severity: { type: alertData?.notification_type },
        recommendedAction: alertData?.detail,
        trigger: {
          thresholdValue: alertData?.trigger?.thresholdValue ?? 0,
          thresholdExplanation:
            alertData?.trigger?.thresholdExplanation ??
            "No threshold explanation provided",
          currentValue: alertData?.trigger?.currentValue ?? null,
          unit: alertData?.trigger?.unit ?? "km",
          timestamp: alertData?.trigger?.timestamp ?? new Date().toISOString(),
        },
      },
      shipment: {
        referenceId: shipment?.reference_number,
        currentLocation: {
          lat: shipment?.latest_location?.latest_lat ?? null,
          lng: shipment?.latest_location?.latest_long ?? null,
          address: shipment?.latest_location?.address ?? "Unknown",
        },
        destination: {
          address: shipment?.to_location?.address,
          eta: shipment?.transport_provider_eta,
          notes: shipment?.to_location?.notes ?? "",
        },
        temperature: {
          current: shipment?.temperature?.current,
          range: {
            min: shipment?.product?.temperature_min,
            max: shipment?.product?.temperature_max,
          },
          uom: shipment?.product?.temperature_unit ?? "C",
        },
        status: {
          pickupTime: shipment?.actual_pickup_date,
          lastUpdate: shipment?.updated_at,
          delivered: shipment?.status,
        },
        transport: {
          provider: shipment?.courier?.title,
          trackingId: shipment?.courier_tracking_id,
          status: shipment?.delivery_status,
        },
        sensor: {
          id: shipment?.sensor_id,
          type: shipment?.sensor?.type,
          battery: {
            currentLevel: shipment?.sensor?.battery?.currentLevel,
            estimatedLife: shipment?.sensor?.battery?.estimatedLife,
            uom: shipment?.sensor?.battery?.uom ?? "hours",
          },
        },
        viabilityWindow: {
          remainingTime: shipment?.schedule_viability_window,
          endTime: null,
          isCritical: alertData?.isCritical,
        },
      },
      contacts: shipment?.tp_primary_contact
        ? {
            primary: {
              name: shipment.tp_primary_contact.name,
              phone: shipment.tp_primary_contact.phone,
              role: shipment.tp_primary_contact.role,
            },
          }
        : {},
    };

    const aiStatusPayload = {
      alert_id: alertData?.id,
      ai_status: "ai_call_in_progress",
      primary_contact: shipment?.tp_primary_contact
        ? {
            name: shipment.tp_primary_contact.name,
            email: shipment.tp_primary_contact.email,
            role: shipment.tp_primary_contact.role,
            phone: shipment.tp_primary_contact.phone,
          }
        : {},
    };

    console.log("ca;ll payload", { aiCallPayload, aiStatusPayload });
    showSpin();

    initiateAiCallValidate(aiCallPayload)
      .then((res) => {
        if (res?.status === "success") {
          message.success(res?.message);
          return initiateAiCall(aiCallPayload);
        } else {
          message.error(
            res?.data?.data?.message || "AI call validation failed"
          );
          throw new Error("AI call validation failed");
        }
      })
      .then((callRes) => {
        if (callRes?.status === "success") {
          message.success("AI call initiated successfully.");
          return shipmentAlertAiStatus(token, aiStatusPayload);
        } else {
          message.error(
            callRes?.data?.data?.message || "AI call failed to initiate"
          );
          throw new Error("AI call failed to initiate");
        }
      })
      .then((statusRes) => {
        setModalOpen(false);
        // if (statusRes?.data?.data?.is_success === true) {
        //   fetchShipmentAlertData();
        //   message.success(statusRes?.data?.data?.message);
        //   setShowAiModal(false);
        // }
      })
      .catch((error) => {
        console.error("AI Call Error:", error);
        message.error(
          error?.data?.message || error.message || "Something went wrong"
        );
      })
      .finally(() => {
        hideSpin();
      });
  };

  useEffect(() => {
    if (isEditing) {
      if (
        selectedNotificationMethod === selected?.notification_method &&
        selected?.message?.body_text
      ) {
        setAiMessage(selected.message.body_text);
      } else {
        setAiMessage(defaultMessage);
      }
    } else {
      setAiMessage(defaultMessage);
    }
  }, [selectedNotificationMethod, selected, isEditing]);

  const isCall = selectedNotificationMethod === "AI_CALL";
  const isEmail = selectedNotificationMethod === "AI_EMAIL";

  if (!isCall && !isEmail) return null;

  return (
    <div>
      {isEditing ? (
        <div style={{ maxWidth: 600 }}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <CustomTitle
              text={isCall ? "Customize script" : "Customize message"}
              fontSize={14}
              color="#000"
              fontWeight="600"
              marginBottom="0"
            />
            <CustomButton
              text="Save"
              bgColor="#000"
              color="#fff"
              fontSize="12px"
              fontWeight={600}
              height="28px"
              padding="0 16px"
              borderRadius="28px"
              onClick={() => setIsEditing(false)}
            />
          </div>

          <textarea
            value={aiMessage}
            onChange={handleMessageChange}
            style={{
              width: "100%",
              height: 174,
              fontFamily: "monospace",
              outline: "none",
              fontSize: 13,
              borderRadius: 8,
              background: "#F3F3F3",
              padding: 12,
              border: "1px solid transparent",
              resize: "none",
              lineHeight: 1.5,
            }}
          />

          <CustomParagraph
            text={`The ZoomLogi AI assistant will ${
              isCall ? "call" : "email"
            } the recipient(s) on ${companyName}'s behalf with your ${
              isCall ? "script" : "message"
            }. The exchange will be logged in the shipment’s chain of custody, and you’ll receive a summary ${
              isCall ? "transcript" : "email"
            }.`}
            fontSize="12px"
            color="#666"
            marginTop="12px"
          />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 4,
              maxWidth: 600,
            }}
          >
            <CustomTitle
              text={isCall ? "Call preview" : "Email preview"}
              fontSize={14}
              color="#000"
              fontWeight="600"
              marginBottom="0"
            />

            <div style={{ display: "flex", gap: 8 }}>
              {isCall && (
                <CustomButton
                  iconPosition="left"
                  image={phoneblack}
                  text="Test AI Call"
                  isFormValid={true}
                  fontSize="12px"
                  fontWeight="600"
                  height="28px"
                  boxShadow="none"
                  bgColor="#F5F5F5"
                  color="#000"
                  padding="0 12px"
                  paddingImage="5px"
                  borderRadius="28px"
                  onClick={() => setModalOpen(true)}
                />
              )}

              <CustomButton
                iconPosition="left"
                text={isCall ? "Customize script" : "Customize message"}
                icon={
                  <EditFilled style={{ fontSize: 12, marginRight: "10px" }} />
                }
                bgColor="#F5F5F5"
                color="#000"
                fontSize="12px"
                boxShadow="none"
                borderRadius="28px"
                fontWeight="600"
                height="28px"
                padding="0 12px"
                onClick={() => setIsEditing(true)}
              />
            </div>
          </div>

          <img
            src={isCall ? callPreviewImage : emailPreviewImage}
            alt="AI Preview"
            style={{
              width: "100%",
              maxWidth: 600,
              borderRadius: 8,
              border: "1px solid #E2E2E2",
              display: "block",
            }}
          />

          <CustomParagraph
            text={`The ZoomLogi AI assistant will ${
              isCall ? "call" : "email"
            } the recipient(s) on ${companyName}’s behalf with your ${
              isCall ? "script" : "message"
            }. The exchange will be logged in the shipment’s chain of custody, and you’ll receive a summary ${
              isCall ? "transcript" : "email"
            }.`}
            fontSize="12px"
            color="#5E5E5E"
            marginTop="12px"
            marginBottom={0}
            maxWidth="600px"
          />
        </>
      )}
      <CustomModalWithoutButton
        modalOpen={modalOpen}
        fontSize="20px"
        setModalOpen={setModalOpen}
        modalTitle="Test call"
        modalText="The ZoomLogi AI assistant will call you at (555) 671-0091 — the number from your profile."
        modalSize={480}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <CustomButton
            text="Cancel"
            bgColor="#fff"
            color="#000"
            boxShadow={"none"}
            fontSize="14px"
            fontWeight="600"
            height="36px"
            padding="0 16px"
            borderRadius="8px"
            onClick={() => setModalOpen(false)}
          />
          <CustomButton
            text="Call me now"
            bgColor="#000"
            color="#fff"
            boxShadow={"none"}
            fontSize="14px"
            fontWeight="600"
            height="36px"
            padding="0 16px"
            borderRadius="8px"
            onClick={() => {
              handleAiCallConfirm();
            }}
          />
        </div>
      </CustomModalWithoutButton>
    </div>
  );
};

export default AiAssistance;
